import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { SvgNmrAssignment2 } from 'cheminfo-font';
import { FaBolt } from 'react-icons/fa';
import { isSpectrum1D } from '../../../data/data1d/Spectrum1D/isSpectrum1D';
import { useChartData } from '../../context/ChartContext';
import Button from '../../elements/Button';
import { tablePanelStyle } from '../extra/BasicPanelStyle';
import DefaultPanelHeader from '../header/DefaultPanelHeader';
import { SpectraAutomaticPickingButton } from '../header/SpectraAutomaticPickingButton';
import AutomaticAssignmentTable from './AutomaticAssignmentTable';
import { useAutoAssignments } from './useAutoAssignments';
function useCheckEnableAutomaticAssignments() {
    const { data } = useChartData();
    return data.some((spectrum) => {
        if (isSpectrum1D(spectrum)) {
            return spectrum?.ranges?.values.length > 0;
        }
        return spectrum?.zones?.values.length > 0;
    });
}
function AutomaticAssignment() {
    const { getAssignments, assignments, restAssignments } = useAutoAssignments();
    const enabled = useCheckEnableAutomaticAssignments();
    return (_jsxs("div", { css: tablePanelStyle, children: [_jsxs(DefaultPanelHeader, { showSettingButton: false, canDelete: false, children: [_jsx(SpectraAutomaticPickingButton, {}), _jsx(Button.BarButton, { tooltipOrientation: "horizontal", toolTip: "automatic assignment", onClick: getAssignments, disabled: !enabled, children: _jsx(SvgNmrAssignment2, {}) }), _jsx(Button.BarButton, { tooltipOrientation: "horizontal", toolTip: "reset assignment", onClick: restAssignments, children: _jsx(FaBolt, {}) })] }), _jsx("div", { className: "inner-container", children: _jsx(AutomaticAssignmentTable, { data: assignments }) })] }));
}
export default AutomaticAssignment;
